"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.546 5.953a.7.7 0 0 1 .638.412l3.938 8.719q.03.051.049.108l.842 1.863a.7.7 0 0 1-1.276.577l-.68-1.507H5.02l-.683 1.507a.7.7 0 1 1-1.276-.578l.834-1.837a.7.7 0 0 1 .07-.157l3.942-8.696a.7.7 0 0 1 .638-.41m-2.89 8.772h5.768L8.544 8.35zM18.732 6.03a.7.7 0 0 1 .381.623v9.994H20.3a.7.7 0 1 1 0 1.4h-4.001a.7.7 0 0 1-.001-1.4l1.416-.002v-8.62l-1.383 1a.7.7 0 0 1-.82-1.135l2.492-1.804a.7.7 0 0 1 .729-.056",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AlphaNumericIcon24.js.map